"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncAdAccountTableContainer = AsyncAdAccountTableContainer;
exports.AsyncAdsLeadSyncingTableContainer = AsyncAdsLeadSyncingTableContainer;
exports.AsyncAdsPixelTableContainer = AsyncAdsPixelTableContainer;
exports.AsyncAdsROICalculationContainer = AsyncAdsROICalculationContainer;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var AdAccountTableContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/AdAccountTableContainer'
    /* webpackChunkName: "chunk-marketing-ads" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncAdAccountTableContainer(props) {
  return _react.default.createElement(AdAccountTableContainer, props);
}

var AdsLeadSyncingTableContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/AdsLeadSyncingTableContainer'
    /* webpackChunkName: "chunk-marketing-ads" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncAdsLeadSyncingTableContainer(props) {
  return _react.default.createElement(AdsLeadSyncingTableContainer, props);
}

var AdsPixelTableContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/AdsPixelTableContainer'
    /* webpackChunkName: "chunk-marketing-ads" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncAdsPixelTableContainer(props) {
  return _react.default.createElement(AdsPixelTableContainer, props);
}

var AdsROICalculationContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./containers/AdsROICalculationContainer'
    /* webpackChunkName: "chunk-marketing-ads" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingSpinner.default, {
      grow: true,
      minHeight: 200
    });
  }
});

function AsyncAdsROICalculationContainer(props) {
  return _react.default.createElement(AdsROICalculationContainer, props);
}